import { AbstractScheduler } from './abstract.scheduler';
export class ImmediateTaskScheduler extends AbstractScheduler {
  schedule(callback) {
    callback();
    return null;
  }
}